import { v4 as uuid } from 'uuid';

import { startPollingMessages } from './startPollingMessages';
import { setChatbotMessageSending, setChatbotOnboardingButtons } from '../../actions/chatbot/actions';
import { addTextMessageToChat } from '../../actions/sendMessage';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { CHATBOT_PAYLOAD } from '../../constants/chatbotPayload';
import { chatbotSelector } from '../../selectors';
import { TChatbotPayload, fetchChatbotActionButtons } from '../../services/сhatbot/fetchChatbotActionButtons';
import { TThunkAction } from '../../types/redux/thunk';

export const getChatbotActionButtons =
  (payload: TChatbotPayload, message?: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { messageSending: isMessageSending } = chatbotSelector(getState());

    if (isMessageSending && payload !== CHATBOT_PAYLOAD.SendMessage) {
      return;
    }

    if (payload !== CHATBOT_PAYLOAD.Initial && payload !== CHATBOT_PAYLOAD.Closing) {
      dispatch(setChatbotMessageSending(true));
    }

    const messageId = uuid();

    if (message) {
      dispatch(addTextMessageToChat(message, CHATBOT_ID, messageId));
    }

    await fetchChatbotActionButtons(context, payload);

    if (payload !== CHATBOT_PAYLOAD.Initial) {
      dispatch(setChatbotOnboardingButtons([]));
      dispatch(
        startPollingMessages({
          isQuick: true,
          messageIdToDelete: message && messageId,
        }),
      );
    }
  };
